import React from "react";
import { Divider, Switch } from "@mui/material";
import Space from "../layout/Space";
import Icon1 from "../icons/Icon";
import { useSnackbar } from "notistack";
import { useState } from "react";
import { useEffect } from "react";
import { useAuth } from "../auth/FirebaseAuth";
import { getUserById } from "../models/UserFunctions";
import { getOrgById, getOrgByRef } from "../models/OrgFunctions";
import { useAppContext } from "../config/AppContext";
import CheckBoxGrey from "../textfields/CheckBoxGrey";
import { useTheme } from "@mui/material";
import downloadCoChampImages from "../api/download/downloadCoChampImages";
import SecondaryButton from "../buttons/SecondaryButton";
import downloadAllControlImages from "../api/download/downloadAllControlImages";
import Modal1 from "../modals/Modal1";
import TextField2 from "../textfields/TextField2";
import PrimaryButton from "../buttons/PrimaryButton";
import { updateDoc } from "firebase/firestore";
import updateDocApi from "../api/database/updateDocApi";
import { directoryOpen } from "browser-fs-access";
import sendConformityReport from "../api/send/sendConformityReport";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken";
import { tr } from "date-fns/locale";
import {
  getDocDataById,
  getDocDataByRef,
  getFlutterTime,
  queryCollection,
} from "../models/DataFunctions";
import SmallSpinner from "../loading/SmallSpinner";
import DropDownGPT03 from "../dropdowns/DropDownGTP03";
import TabGPT from "../tabs/TabGPT";
import getControlPresginedUrls from "../api/presigned/getControlPresignedUrls";

const Control = ({ onClose, first_control, folder }) => {
  const [userData, setUserData] = useState(null);
  const [orgData, setOrgData] = useState(null);
  const { currentUser, loading } = useAuth();
  const [control, setControl] = useState(first_control);
  const [tabs = [], setTabs] = useState([
    {
      label: first_control.name,
      id: first_control.cid,
    },
  ]);
  const [activeTab, setActiveTab] = useState(first_control.cid);
  const [controls, setControls] = useState([first_control]);
  const [message, SetMessage] = useState(null);
  const [modify, setModify] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  const handleDownloadImage = (url, name) => {
    try {
      if (!url || typeof url !== "string") {
        throw new Error("Invalid URL provided.");
      }

      if (!name || typeof name !== "string") {
        throw new Error("Invalid file name provided.");
      }

      // Use `fetch` to download the file and create a Blob
      fetch(url)
        .then((response) => {
          if (!response.ok) {
            throw new Error(
              `Failed to fetch the image: ${response.statusText}`
            );
          }
          return response.blob();
        })
        .then((blob) => {
          // Create a temporary URL for the Blob
          const blobUrl = URL.createObjectURL(blob);

          // Create a link element
          const link = document.createElement("a");
          link.href = blobUrl;
          link.download = name;

          // Append the link, trigger click, and remove it
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          // Revoke the Blob URL
          URL.revokeObjectURL(blobUrl);
        })
        .catch((error) => {
          console.error("Error downloading image:", error.message);
        });
    } catch (error) {
      console.error("Error in handleDownloadImage:", error.message);
    }
  };
  const [loadingGenerateForm, setLoadingGenerateForm] = useState(false);
  const [loadingDownloadImages, setLoadingDownloadImages] = useState(false);

  const handleDownloadControlForm = async (control) => {
    try {
      let folder = await getDocDataByRef(control.folder_ref);

      // if (!folder.conductor_id && !folder.particulier?.email && folder.folder_type == "infiltro") {
      //   handleClickVariant(
      //     "Le dossier n'a pas de conducteur de chantier alors qu'il n'est pas lié à un particulier",
      //     "error"
      //   );
      //   return;
      // }
      if (!folder.members_id || folder.members_id.length == 0) {
        handleClickVariant("Le dossier n'a pas d'opérateur", "error");
        return;
      }
      if (!folder.xml?.file?.id) {
        handleClickVariant("Le dossier n'a pas de fichier xml", "error");
        return;
      }

      // Get all categories from the control automatically
      const categories_selected = control.cochamps ? control.cochamps.map(cochamp => cochamp.name) : [];

      setLoadingGenerateForm(true);
      const token = await getOrRefreshFirebaseToken();
      await getControlPresginedUrls(control.id, token, prefix);
      
      const res = await sendConformityReport(
        folder.id,
        control.id,
        categories_selected,
        `Formulaire_control_${folder.nom.replace(/ /g, "_")}_${new Date().toLocaleDateString().replace(/\//g, "_")}.pdf`,
        `Formulaire de contrôle - ${control.name}`,
        token,
        prefix,
        handleClickVariant,
        true
      );
      
      if (res.success && res.url) {
        // Download the generated PDF using fetch to force download
        try {
          const response = await fetch(res.url);
          const blob = await response.blob();
          const blobUrl = URL.createObjectURL(blob);
          
          const link = document.createElement("a");
          link.href = blobUrl;
          link.download = `Formulaire_control_${folder.nom.replace(/ /g, "_")}_${new Date().toLocaleDateString().replace(/\//g, "_")}.pdf`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          
          // Clean up the blob URL
          URL.revokeObjectURL(blobUrl);
          
          handleClickVariant("Formulaire généré et téléchargé", "success");
        } catch (downloadError) {
          console.error("Error downloading file:", downloadError);
          handleClickVariant("Erreur lors du téléchargement", "error");
        }
      } else if (res.success) {
        handleClickVariant("Rapport de contrôle généré", "success");
      }
      setLoadingGenerateForm(false);
    } catch (error) {
      handleClickVariant(
        "Erreur lors de la génération du rapport de contrôle.",
        "error"
      );
      console.error("Error generating conformity report:", error.message);
      setLoadingGenerateForm(false);
    }
  };

  function oneOfMyChampIsAnImage(cochamp) {
    let isAnImage = false;
    cochamp.champs.forEach((champ) => {
      if (
        (champ.type === "img" && champ.content?.length > 0) ||
        (champ.type === "imgtext" && champ.content?.length > 0)
      ) {
        isAnImage = true;
      }
    });
    return isAnImage;
  }

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const handleFetchData = async () => {
    if (currentUser) {
      try {
        const user = await getUserById(currentUser.uid);
        const org = await getOrgById(user.org_id);
        let event = await getDocDataByRef(first_control.eventref);
        let controls = [];
        for (let i = 0; i < event.control_ids?.length || 0; i++) {
          let filters = [
            {
              field: "cid",
              operator: "==",
              value: event.control_ids[i],
            },
          ];
          let controll = await queryCollection("control", filters);
          if (controll.length === 0) {
            continue;
          } else {
            controls.push(controll[0]);
          }
        }
        setTabs(
          controls.map((control) => {
            return {
              label: control.name,
              id: control.cid,
            };
          })
        );

        setControls(controls);
        let new_control =
          controls.find((c) => c.cid === activeTab) || first_control;
        const token = await getOrRefreshFirebaseToken();
        await getControlPresginedUrls(new_control.id, token, prefix);
        let fresh_control = await getDocDataById("control", new_control.id);
        setControl(fresh_control);
        setActiveTab(new_control.cid);

        setUserData(user);
        setOrgData(org);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  const handleSaveModifications = async () => {
    try {
      if (!control || !control.id) {
        throw new Error("Invalid control object provided.");
      }

      let new_control = {
        ...control,
        lastupdated: getFlutterTime(),
      };
      await updateDocApi(control.ref, new_control, prefix);

      setModify(false);
      handleClickVariant("Modifications enregistrées avec succès.", "success");
    } catch (error) {
      console.error("Error saving modifications:", error);
      handleClickVariant(
        "Erreur lors de l'enregistrement des modifications.",
        "error"
      );
    }
  };

  const handleUpdateChamp = async (new_value, champ, cochamp, control) => {
    try {
      if (!champ || !champ.name || !champ.type) {
        throw new Error("Invalid champ object provided.");
      }

      if (!cochamp || !cochamp.name || !cochamp.champs) {
        throw new Error("Invalid cochamp object provided.");
      }

      if (!control || !control.id) {
        throw new Error("Invalid control object provided.");
      }

      const updatedChamp = {
        ...champ,
        content: [new_value],
      };

      const updatedCoChamp = {
        ...cochamp,
        champs: cochamp.champs.map((c) =>
          c.name === champ.name ? updatedChamp : c
        ),

        lastupdated: getFlutterTime(),
      };

      const updatedControl = {
        ...control,
        cochamps: control.cochamps.map((c) =>
          c.name === cochamp.name ? updatedCoChamp : c
        ),
        lastupdated: getFlutterTime(),
      };

      setControl(updatedControl);
    } catch (error) {
      console.error("Error updating champ:", error);
      handleClickVariant("Erreur lors de la mise à jour du champ.", "error");
    }
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const [bigPhoto, setBigPhoto] = useState(null);

  const theme = useTheme();
  useEffect(() => {
    if (currentUser) {
      handleFetchData();
    }
  }, [currentUser, activeTab]);

  if (loading || !currentUser || !userData) {
    return (
      <div className="bg-white p-4 rounded-md">
        <SmallSpinner></SmallSpinner>
      </div>
    );
  }

  return (
    <div
      className=" flex  p-10 w-c1k  h-screen select-text "
      onClick={handleBackdropClick}
    >
      <Modal1 isOpen={bigPhoto} onClose={() => setBigPhoto(null)}>
        <div
          className=" flex flex-col  rounded-xl items-center justify-center h-screen w-screen cursor-pointer"
          onClick={() => setBigPhoto(null)}
        >
          <img
            src={bigPhoto}
            alt="photo"
            className="rounded-xl h-c700 object-contain"
          />
        </div>
      </Modal1>
      <div className="relative bg-white flex flex-col p-4 w-full   h-full rounded-3xl ">
        {modify && (
          <div className="absolute bottom-8 right-16">
            <PrimaryButton onClick={handleSaveModifications}>
              Enregistrer les modifications
            </PrimaryButton>
          </div>
        )}
        <div className="flex flex-col overflow-y-auto h-full gap-3 w-full">
          <div className="flex flex-row justify-between p-r-2">
            {" "}
            <div className="text-h3 font-bold">Contrôle</div>
            <div className="text-h4  text-shadow_10 select-text">
              {control.id}
            </div>
            <div
              className="text-h3 text-shadow_50 mr-2 cursor-pointer border-1 border-shadow_50 rounded-lg px-2 py-0.5  hover:shadow-md"
              onClick={onClose}
            >
              Fermer
            </div>
          </div>
          <TabGPT
            tabs={tabs}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          ></TabGPT>
          <div className="flex flex-col">
            <div className="flex flex-row gap-2">
              {" "}
              <div className="text-h3 w-c50">Nom</div>
              <div className="text-h3 ">{control.name}</div>
            </div>
            {modify && (
              <TextField2
                className="max-w-c300"
                value={control.name}
                onChange={(e) =>
                  setControl({ ...control, name: e?.target?.value || "" })
                }
              />
            )}
            <div className="flex flex-row gap-2">
              {" "}
              <div className="text-h3 w-c50">Date</div>
              <div className="text-h3 ">
                {new Date(control.date.seconds * 1000).toLocaleDateString()}
              </div>
            </div>{" "}
            <div className="flex flex-row gap-2">
              {" "}
              <div className="text-h3 w-c50">Ville</div>
              <div className="text-h3 ">{control.ville}</div>
            </div>
            <div className="flex flex-row gap-2 text-shadow_50">
              {" "}
              <div className="text-h3 ">Dernière modification</div>
              <div className="text-h3 ">
                {new Date(control.lastupdated.seconds * 1000).toLocaleString()}
              </div>
            </div>
            <div className="flex flex-row gap-2 items-center">
              <div
                className="relative w-c70 h-4 border-2 rounded-3xl border-shadow_50 z-10"
                style={{
                  borderColor:
                    control.pourcentage === 100
                      ? theme.palette.accent1.mobile
                      : theme.palette.shadow._25,
                }}
              >
                <div
                  className="relative h-full rounded-l-2xl z-0"
                  style={{
                    backgroundColor:
                      control.pourcentage === 100
                        ? theme.palette.accent1.mobile
                        : theme.palette.shadow._25,
                    width: `${control.pourcentage}%`,
                    borderTopRightRadius:
                      control.pourcentage > 95 ? "50px" : "0",
                    borderBottomRightRadius:
                      control.pourcentage > 95 ? "50px" : "0",
                    borderTopLeftRadius: "50px",
                    borderBottomLeftRadius: "50px",
                  }}
                ></div>
              </div>
              <div className="text-h3 text-shadow_50">
                {control.pourcentage + "%"}
              </div>
            </div>
            <div className="flex flex-col gap-1 mt-2">
              {" "}
              <SecondaryButton
                className="w-fit"
                onClick={() => setModify(!modify)}
              >
                {modify
                  ? "Annuler la modification du contrôle"
                  : "Modifier le contrôle"}
              </SecondaryButton>
              <SecondaryButton
                disabled={loadingGenerateForm}
                className="w-fit"
                onClick={() => handleDownloadControlForm(control)}
              >
                Télécharger en format PDF{" "}
                <SmallSpinner loading={loadingGenerateForm}></SmallSpinner>
              </SecondaryButton>{" "}
              <SecondaryButton
                disabled={loadingDownloadImages}
                className="w-fit"
                onClick={async () => {
                  setLoadingDownloadImages(true);
                  try {
                    await downloadAllControlImages(control, folder.nom);
                  } finally {
                    setLoadingDownloadImages(false);
                  }
                }}
              >
                Télécharger toutes les images{" "}
                <SmallSpinner loading={loadingDownloadImages}></SmallSpinner>
              </SecondaryButton>{" "}
            </div>{" "}
          </div>

          {control.cochamps.map((cochamp, index) => (
            <div key={index} className="flex flex-col gap-2">
              <Space y={10}></Space>
              <div className="flex flex-col">
                <div className="text-h3 font-bold flex flex-row gap-2">
                  {cochamp.name}{" "}
                  {oneOfMyChampIsAnImage(cochamp) && (
                    <div
                      className="cursor-pointer"
                      onClick={() => downloadCoChampImages(cochamp)}
                    >
                      <Icon1 icon_name="download" size={18} fill="grey"></Icon1>
                    </div>
                  )}
                </div>
                <Divider></Divider>
              </div>
              <div className="flex flex-col gap-2 ml-4">
                {cochamp.champs &&
                  Array.isArray(cochamp.champs) &&
                  cochamp.champs.map((champ, index) => (
                    <div
                      key={index}
                      className="flex flex-row items-start gap-2"
                    >
                      <div className="text-h3 font-normal text-shadow_50">
                        {champ.name}{" "}
                      </div>
                      <div className="flex flex-col  ">
                        {champ.type === "drop" && (
                          <>
                            {modify === false ? (
                              <>
                                {champ.content &&
                                  Array.isArray(champ.content) &&
                                  champ.content.map((item, index) => (
                                    <div key={index}>
                                      <div className="text-h3 ">{item}</div>
                                    </div>
                                  ))}
                              </>
                            ) : (
                              <>
                                <DropDownGPT03
                                  className={"w-c300"}
                                  items={champ.options.map((item) => {
                                    return { label: item, value: item };
                                  })}
                                  value={champ.content[0]}
                                  onChange={(e) =>
                                    handleUpdateChamp(
                                      e.value,
                                      champ,
                                      cochamp,
                                      control
                                    )
                                  }
                                ></DropDownGPT03>
                              </>
                            )}
                          </>
                        )}
                      </div>

                      {champ.type === "text" && champ.content && (
                        <>
                          <div className="text-h3">{champ.content[0]}</div>
                          {modify && (
                            <TextField2
                              className="max-w-c200"
                              value={champ.content[0]}
                              onChange={(e) =>
                                handleUpdateChamp(
                                  e?.target?.value || "",
                                  champ,
                                  cochamp,
                                  control
                                )
                              }
                            />
                          )}
                        </>
                      )}
                      <div className="flex flex-wrap gap-2">
                        {champ.type === "img" &&
                          champ.content?.length > 0 &&
                          champ.content.map((img, index) => (
                            <div key={index}>
                              <div
                                className="w-fit h-fit cursor-pointer"
                                onClick={() => setBigPhoto(img)}
                              >
                                <img
                                  key={index}
                                  src={`${img}`}
                                  className="w-20 h-20 rounded-lg"
                                ></img>
                              </div>
                              <div
                                className="cursor-pointer"
                                onClick={() =>
                                  handleDownloadImage(
                                    img,
                                    champ.name + "_" + index.toString() + ".jpg"
                                  )
                                }
                              >
                                <Icon1
                                  icon_name="download"
                                  size={18}
                                  fill="grey"
                                ></Icon1>
                              </div>
                            </div>
                          ))}
                      </div>
                      {champ.type === "imgtext" && champ.content && (
                        <div className="text-h3">{champ.content[0]}</div>
                      )}
                      {champ.type === "imgtext" &&
                        champ.content?.length > 0 &&
                        champ.content[1] && (
                          <>
                            <div
                              className="w-fit h-fit cursor-pointer"
                              onClick={() => setBigPhoto(champ.content[1])}
                            >
                              <img
                                src={`${champ.content[1]}`}
                                className="w-20 h-20 rounded-lg"
                              ></img>
                            </div>
                            <div
                              className="cursor-pointer"
                              onClick={() =>
                                handleDownloadImage(
                                  champ.content[1],
                                  champ.name + ".jpg"
                                )
                              }
                            >
                              <Icon1
                                icon_name="download"
                                size={18}
                                fill="grey"
                              ></Icon1>
                            </div>
                          </>
                        )}
                      {champ.type === "case" && champ.content && (
                        <CheckBoxGrey
                          checked={champ.content[0] === "true"}
                        ></CheckBoxGrey>
                      )}
                    </div>
                  ))}
              </div>{" "}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Control;
